export default {
  userNotifications: []
}
